import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Button } from "../../../../../common/Button.tsx";
import { usePayTypeOptions } from "../hooks/useGetAbsenceMappingOptions.js";
import { addNewMapping } from "../../../../../api/index.js";
import { FormNormalSelect } from "../../../../../common/form/formnormalselect.jsx";
import { useGetFormsOfSalaryOptions } from "../hooks/useGetFormsOfSalaryOptions.ts";
import { useEffect } from "react";
import { FormInput } from "../../../../../common/form/forminput.jsx";
import { useGetAbscenceTypesOptions } from "../../../../../mgmtview/personalprofile/newabscencemodal/newabscencemodal.constants.js";
import { capitalizeFirstLetter } from "../../../../../common/utils.jsx";

export const NewEventForm = ({ refetch, integration }) => {
  const { t } = useTranslation();
  const form = useForm({
    defaultValues: {
      absenceType: null,
      paidness: "",
      salaryTypeCode: null,
      formOfSalary: null,
      paymentGroup: "",
      active: null,
    },
  });

  const formsOfSalaryOptions = useGetFormsOfSalaryOptions();
  const { options: eventTypesOptions } = useGetAbscenceTypesOptions();
  const eventType = form.watch("absenceType");

  const payTypeOptions = usePayTypeOptions(integration, "ABSENCE"); // fetch pay type options based on integration

  const submitForm = async (formValues) => {
    if (!(await form.trigger())) return;

    const formData = {
      absenceType: formValues.absenceType?.value || null,
      salaryTypeCode: formValues.salaryTypeCode?.value || null,
      formOfSalary: formValues.formOfSalary?.value || null,
      payrollSystemType: integration,
      paymentGroup: formValues.paymentGroup || "",
      active: formValues.active?.value === "true",
    };

    await addNewMapping(formData);
    refetch();
    form.reset();
  };

  // Päivitä Paidness kun eventType muuttuu
  useEffect(() => {
    if (eventType) {
      form.setValue("paidness", capitalizeFirstLetter(t(eventType.paidness)));
    }
  }, [eventType]);

  return (
    <FormProvider {...form}>
      <div className="d-flex gap-2">
        <FormNormalSelect
          name="absenceType"
          label={t("Event")}
          options={eventTypesOptions}
          selectProps={{
            menuPortalTarget: document.body,
            styles: {
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              menu: (provided) => ({ ...provided, zIndex: 9999 }),
            },
          }}
          required
        />
        <FormInput name="paidness" label={t("Paidness")} inputProps={{ rows: 1, readOnly: true, $resize: "none" }} />
        <FormNormalSelect
          name="salaryTypeCode"
          label={t("SalaryType")}
          options={payTypeOptions}
          required
        />
        <FormNormalSelect name="formOfSalary" label={t("FormOfSalary")} options={formsOfSalaryOptions} />
        <FormInput name="paymentGroup" label={t("PayGroup")} textAreaProps={{ rows: 1, $resize: "none" }} />
        <FormNormalSelect
          name="active"
          label={t("Status")}
          options={[
            { label: t("Active"), value: "true" },
            { label: t("Inactive"), value: "false" },
          ]}
          required
        />
      </div>

      <div className="d-flex justify-content-end mt-2">
        <Button variant="outline-primary" onClick={form.handleSubmit(submitForm)}>
          {t("AddNewRow", "Lisää uusi rivi")}
        </Button>
      </div>
    </FormProvider>
  );
};
